import React from 'react';
import { Container, Card } from 'react-bootstrap';
import PageTitle from '@/common/PageTitle/PageTitle';
import styles from './account-company-profile.module.scss';

const AccountCompanyProfile: React.FC = () => (
  <Container fluid>
    <Card className={styles.card}>
      <Card.Body>
        <Card.Title className={styles.cardTitle}>
          <PageTitle title="Account Company Profile" />
        </Card.Title>
        <div className={styles.profileSection}>
          <div className={styles.avatar} />
          <div className={styles.companyInfo}>
            <div className={styles.companyName}>J&amp;P's Audio Pool Company</div>
            <div className={styles.companyType}>Music Pool</div>
            <div className={styles.companyPhone}>888-394-3919</div>
          </div>
          <div className={styles.editLink}>
            <a href="#"><span role="img" aria-label="edit">✏️</span> Edit</a>
          </div>
        </div>
        <hr />
        <div className={styles.sectionTitle}>Company Information</div>
        <div className={styles.infoGrid}>
          <div className={styles.infoColumn}>
            <div className={`${styles.fieldLabel} ${styles.locked}`}>Company Name</div>
            <div className={styles.fieldValue}>J&amp;P's Audio Pool Company</div>
            <div className={`${styles.fieldLabel} ${styles.fieldLabelSpaced}`}>Company Street Address</div>
            <div className={styles.fieldValue}>1234 Main Street</div>
          </div>
          <div className={styles.infoColumn}>
            <div className={styles.fieldLabel}>Company Phone Number</div>
            <div className={styles.fieldValue}>888-394-3919</div>
          </div>
          <div className={styles.infoColumn}>
            <div className={`${styles.fieldLabel} ${styles.locked}`}>Vendor Type</div>
            <div className={styles.fieldValue}>Music Pool</div>
          </div>
        </div>
      </Card.Body>
    </Card>
  </Container>
);

export default AccountCompanyProfile; 